import React from 'react';
import ClientCard from './ClientCard';
import Swal from 'sweetalert2';

const ClientList = ({ clients, onSelectClient, onNewMeeting, onUpdateClient, onDeleteClient, currentUser }) => {
  const handleDeleteClient = async (clientId) => {
    const result = await Swal.fire({
      title: '¿Eliminar cliente?',
      text: '¿Estás seguro de que quieres eliminar este cliente? Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF0000',
      cancelButtonColor: '#63666A',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await onDeleteClient(clientId);
        await Swal.fire({
          title: '¡Eliminado!',
          text: 'El cliente ha sido eliminado exitosamente.',
          icon: 'success',
          confirmButtonColor: '#0061A8'
        });
      } catch (error) {
        console.error(error);
        await Swal.fire({
          title: 'Error',
          text: 'Error al eliminar el cliente: ' + error.message,
          icon: 'error',
          confirmButtonColor: '#0061A8'
        });
      }
    }
  };

  return (
    <div className="space-y-4">
      {clients.length === 0 ? (
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <svg className="w-16 h-16 mx-auto text-[#D1D3D4] mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p className="text-[#63666A] text-lg">No hay clientes registrados</p>
          <p className="text-[#63666A] text-sm mt-2">Agrega un nuevo cliente para empezar</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {clients.map(client => (
            <ClientCard
              key={client.id}
              client={client}
              onSelect={onSelectClient}
              onNewMeeting={onNewMeeting}
              onUpdateClient={onUpdateClient}
              onDeleteClient={(clientId) => handleDeleteClient(clientId)}
              currentUser={currentUser}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientList;
